import { AbstractControl, ValidationErrors, Validator, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
@Directive({
    selector: '[appIsNumberValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IsNumberValidator, multi: true }]
})
export class IsNumberValidator implements Validator {
    @Input('appIsNumberValidator') checkValue: boolean = true;
    validate(c: AbstractControl): ValidationErrors {
        if (!c.value)
            return null;

        const val = Number(c.value);
        if (this.checkValue && isNaN(val))
            return { 'notNumber': true };

        return null;
    }

    // registerOnValidatorChange?(fn: () => void): void {
    //     throw new Error("Method not implemented.");
    // }
}
